/* eslint-disable */

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  CollectionList,
  Spacer,
  TagFilter,
  TagFilterGroup,
  Title,
  RadioGroup,
  Radio
} from "@common/AggregationComponent";
import { handleHeightLabel } from "@util/common";

export interface FilterModelArgs {
  visible: boolean;
  total: number | string;
  tree: any;
  sizes: any[];
  visibleSize: boolean;
  visibleCategory: boolean;
  categoryType: string;
  selectedSizes: any[];
  filteredSizes: any[];
  selectedCategories: any[];
  searchCategories: any[];
  searchSizes: any[];
  onChangeSelectedSizes: (sizes: any[]) => void;
  onChangeSelectedCategories: (sizes: any[]) => void;
  handlerSizeExpand: () => void;
  handlerCategoryExpand: () => void;
  handlerClearAllFilter: () => void;
  setFilteredSizes: (size: any) => void;
  onClose: () => void;
  setIsClickSizeCheckList: any;
  genders: any;
  selectedGender: any;
  selectedHeight: any;
  onChangeSelected: Function;
  heights: any;
}

const OutfitTabFilterDetails = (props: FilterModelArgs): any => {
  const {
    visibleSize,
    visibleCategory,
    handlerSizeExpand,
    handlerCategoryExpand,
    genders,
    selectedGender,
    selectedHeight,
    onChangeSelected,
    heights
  } = props;
  const { t } = useTranslation();

  const getSelectedTags: any[] = useMemo(() => {
    const newSelectedTags = [];
    if (selectedGender !== "All") {
      newSelectedTags.push(selectedGender);
    }
    if (selectedHeight) {
      newSelectedTags.push(selectedHeight);
    }
    return newSelectedTags;
  }, [selectedGender, selectedHeight]);

  const handlerDeleteTag = (tag: any) => {
    if (tag === selectedGender) {
      handlerClearAll();
    } else if (tag.label === selectedHeight.label) {
      onChangeSelected(selectedGender, "", false);
    }
  };
  const handlerClearAll = () => {
    onChangeSelected("All", "", false);
  };

  return (
    <CollectionList>
      {getSelectedTags.length > 0 && (
        <>
          <Spacer element="div" variant={"spacing-04"} />
          <Title element="p" className="fr-ec-mb-spacing-04">
            {t("text_active_filters")}
          </Title>
          <TagFilterGroup
            clearLabel={t("text_image_search_clear_all_filters")}
            onClear={handlerClearAll}
          >
            {getSelectedTags.map((tag: any) => {
              if (typeof tag === "string") {
                return (
                  <TagFilter
                    disabled={false}
                    value={tag}
                    key={tag}
                    onClick={() => {
                      handlerDeleteTag(tag);
                    }}
                  />
                );
              } else {
                return (
                  <TagFilter
                    disabled={false}
                    value={handleHeightLabel(tag, t)}
                    key={tag.value}
                    onClick={() => {
                      handlerDeleteTag(tag);
                    }}
                  />
                );
              }
            })}
          </TagFilterGroup>
          <Spacer element="div" variant={"spacing-05"} />
        </>
      )}
      <Accordion
        disabled={false}
        element="div"
        id="accordion-id"
        label={t("text_category")}
        labelChildren=""
        labelElement="h5"
        onClose={handlerCategoryExpand}
        onExpand={handlerCategoryExpand}
        variant="dynamic"
        expanded={visibleCategory}
      >
        <Spacer element="div" variant="spacing-04" />
        <RadioGroup columnCount={{ sm: 2, md: 2, lg: 2 }}>
          {genders.map((gender: any) => (
            <Radio
              checked={gender.name === selectedGender}
              id={`outfit-tab-new-filter-height-gender-detail-${gender.id}`}
              key={`outfit-tab-new-filter-detail-${gender.id}`}
              label={gender.name}
              name="outfit-tab-new-filter-gender-radio-detail"
              onChange={() => {
                onChangeSelected(gender.name, selectedHeight, true);
              }}
              value={`outfit-tab-new-filter-detail-${gender.id}`}
            />
          ))}
        </RadioGroup>
        <Spacer element="div" variant="spacing-04" />
      </Accordion>
      <Accordion
        disabled={false}
        element="div"
        id="accordion-id"
        label={t("text_height")}
        labelChildren=""
        labelElement="h5"
        onClose={handlerSizeExpand}
        onExpand={handlerSizeExpand}
        variant="dynamic"
        expanded={visibleSize}
      >
        <Spacer element="div" variant="spacing-04" />
        <RadioGroup columnCount={{ sm: 2, md: 2, lg: 2 }}>
          {heights.map((height: any) => (
            <Radio
              checked={height.value === selectedHeight.value}
              id={`outfit-tab-new-filter-height-raido-detail-${height.value}`}
              key={`outfit-tab-new-filter-detail-${height.key}`}
              label={handleHeightLabel(height, t)}
              name="outfit-tab-new-filter-height-radio-detail"
              onChange={() => {
                onChangeSelected(selectedGender, height, false);
              }}
              value={height.value}
            />
          ))}
        </RadioGroup>
        <Spacer element="div" variant="spacing-04" />
      </Accordion>
    </CollectionList>
  );
};

export default OutfitTabFilterDetails;
